import DataSentryDashboard from 'pages/dataSentry/dashboard/DataSentryDashboard'
import { DataSentryProvider } from '../context/DataSentryContext'

export const DataSentryContainer: React.FC = () => {
  return (
    <DataSentryProvider>
      <DataSentryDashboard />
    </DataSentryProvider>
  )
}
